
  import * as myProviderRuntime$_9PaoFLwplMPcWtIY3Lo3yXAcA4NDKoDk487CsRr7wg4 from '/app/providers/digitalocean.ts'
import * as pocketbaseRuntime$_9PaoFLwplMPcWtIY3Lo3yXAcA4NDKoDk487CsRr7wg4 from '/app/providers/digitalocean.ts'
import * as ipxRuntime$XaNoWDeV8IbTwm0QpvPnfuCj3CVX36k_7zldApzqThk from '/app/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.11.0_magicast@0.5.3_srvx@0.11.16/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['digitalocean']: { provider: myProviderRuntime$_9PaoFLwplMPcWtIY3Lo3yXAcA4NDKoDk487CsRr7wg4, defaults: {"baseURL":"https://web-site-static.fra1.cdn.digitaloceanspaces.com/nuxt-app"} },
  ['pocketbase']: { provider: pocketbaseRuntime$_9PaoFLwplMPcWtIY3Lo3yXAcA4NDKoDk487CsRr7wg4, defaults: {"baseURL":"https://api.orthodgt.com/api/files/_pb_users_auth_"} },
  ['ipx']: { provider: ipxRuntime$XaNoWDeV8IbTwm0QpvPnfuCj3CVX36k_7zldApzqThk, defaults: {} }
    }
  }
